<form #usernameForm="ngForm" class="auth-form" (ngSubmit)="usernameForm.valid && forgotUsername()">
  <h1>Forgot Username?</h1>
  <div>
    <div id="orange_separator"></div>
  </div>
  <p *ngIf="successUsername" class="alert alert-success">
    Email has been sent to your email address.<br>
    <a routerLink="/login">Click here to login.</a>
  </p>
  <div *ngIf="!successUsername">
    <app-copyable-message *ngIf="errorUsername" variant="danger" extraClass="mb-3" [message]="errorUsername"></app-copyable-message>
    <p class="desc">
      Please provide us with your Email and username will be sent to you.
    </p>
    <div class="field">
      <label class="required" for="forgot-email">Email</label>
      <input type="email" id="forgot-email" placeholder="you@example.com" autocomplete="email"
        [(ngModel)]="email" class="form-control" bkInput name="email" required email #forgotEmail="ngModel" />
      <div *ngIf="forgotEmail.errors?.email && (forgotEmail.dirty || forgotEmail.touched)" class="invalid-feedback">
        <span>Please input a valid email address.</span>
      </div>
    </div>
    <button bkButton color="primary" size="lg" block [disabled]="loading" [loading]="loading">Enter</button>
  </div>
</form>

<form #passwordForm="ngForm" class="auth-form auth-form--stacked" (ngSubmit)="passwordForm.valid && forgotPassword()">
  <h1>Forgot Password?</h1>
  <div>
    <div id="orange_separator"></div>
  </div>
  <p *ngIf="successPassword" class="alert alert-success">
    Email has been sent to your email address.<br>
    <a routerLink="/login">Click here to login.</a>
  </p>
  <div *ngIf="!successPassword">
    <app-copyable-message *ngIf="errorPassword" variant="danger" extraClass="mb-3" [message]="errorPassword"></app-copyable-message>
    <p class="desc">
      Please provide us with your Username and your temporary link will be sent to you.
    </p>
    <div class="field">
      <label class="required" for="forgot-username">Username</label>
      <input type="text" id="forgot-username" placeholder="Your username" autocomplete="username"
        [(ngModel)]="username" class="form-control" bkInput name="username" required />
    </div>
    <button bkButton color="primary" size="lg" block [disabled]="loading" [loading]="loading">Enter</button>
  </div>
</form>
